
import axios from '../common/js/axios'
import {
  host
} from '../common/js/config'

export function getExamList(data) {
  const url = `${host}/app/openExam/queryAllOpenExamList`
  return axios({
    url: url,
    params: data
  })
}

export function getExamForm(data) {
  const url = `${host}/app/openExam/queryOpenExamInfo`
  return axios({
    url: url,
    params: data
  })
}

export function submitExamForm(data) {
  const url = `${host}/app/openExam/saveUserColumnRecord`
  return axios({
    url: url,
    params: data
  })
}
// /app/openExam/save2CheckUserRecord

export function submitForm(data) {
  const url = `${host}/app/openExam/save2CheckUserRecord`
  return axios({
    url: url,
    params: data
  })
}

export function getOpenExamList(data) {
  const url = `${host}/app/openExam/queryOpenExamList`
  return axios({
    url: url,
    params: data
  })
}

export function saveBeforeUserRecord(data) {
  const url = `${host}/app/openExam/saveBeforeUserRecord`
  return axios({
    url: url,
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/signup.js